module.exports = __webpack_public_path__ + "static/img/07.6785593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/07.png
// module id = lNI0
// module chunks = 2